import { Table, TableLoadingRow } from '@foradevelopment/fora-ui';
import { ThunkRequestStatus } from '@fora-monorepo/webapp-types';
import { ReportedPayrollViewModel } from '@fora-monorepo/employer-my-pages-common/types';

import { useTypedTranslation } from '../../../../src/i18n/i18n';
import { PayHistoryTableSortId } from '../../../common/types';
import { useAppSelector } from '../../../redux/hooks';
import { PayHistoryTableRow } from './PayHistoryTableRow';
import { PayHistorySortIdKeys, PayHistorySortState } from './PayHistoryListSortState';

type PayHistoryTableProps = {
  payHistory: ReportedPayrollViewModel[];
  payHistoryListIndices: number[];
  sortTable?: (sortId: PayHistorySortIdKeys) => void;
  sortState: PayHistorySortState;
};

export const PayHistoryTable = ({ payHistory, payHistoryListIndices, sortTable, sortState }: PayHistoryTableProps) => {
  const { t } = useTypedTranslation();

  const isLoadingPayHistory = useAppSelector(state => state.payHistory.loadingPayHistory);
  const sortableTableHeadCells: { name: string; id: PayHistoryTableSortId }[] = [
    { name: t('table.reportLog.columnCompany-1'), id: PayHistoryTableSortId.Organization },
    { name: t('table.payrollHistory.columnId'), id: PayHistoryTableSortId.Id },
    { name: t('table.payrollHistory.columnFistname'), id: PayHistoryTableSortId.FirstName },
    { name: t('table.payrollHistory.columnLastname'), id: PayHistoryTableSortId.LastName },
    { name: t('table.payrollHistory.columnPeriod'), id: PayHistoryTableSortId.Period },
    { name: t('table.payrollHistory.columnRegisteredPay'), id: PayHistoryTableSortId.GrossSalary },
  ];
  return (
    <Table withBorderedRows={true} withExpandableRows={false}>
      <Table.Head>
        <Table.HeadRow>
          {sortableTableHeadCells.map((cell, index) => {
            return (
              <Table.HeadCell
                key={`${cell.id}-${index}`}
                sortId={cell.id}
                onToggle={sortTable as (id: string) => void}
                state={sortState[cell.id]}
                textAlign={index === sortableTableHeadCells.length - 1 ? 'right' : 'left'}
              >
                {cell.name}
              </Table.HeadCell>
            );
          })}
        </Table.HeadRow>
      </Table.Head>
      <Table.Body>
        {isLoadingPayHistory === ThunkRequestStatus.Pending ? (
          <TableLoadingRow />
        ) : (
          payHistoryListIndices.map(payHistoryListIndex => (
            <PayHistoryTableRow
              key={`employment-table-row-${payHistoryListIndex}`}
              testId={`table-row-${payHistoryListIndex}`}
              payHistory={payHistory[payHistoryListIndex]}
            />
          ))
        )}
      </Table.Body>
    </Table>
  );
};
